import { render, staticRenderFns } from "./whats-new-modal.vue?vue&type=template&id=33086092"
import script from "./whats-new-modal.vue?vue&type=script&lang=js"
export * from "./whats-new-modal.vue?vue&type=script&lang=js"
import style0 from "./whats-new-modal.vue?vue&type=style&index=0&id=33086092&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports